import { inject, type ObjectGraph } from '@jet/environment/dependencies';
import { ObjectGraphType } from './object-graph-type';

export enum SubscriberType {
    NotActive = 'notActive',
    Premium = 'premium',
}

export interface UserInfo {
    storefront: string;
    subscriberType: SubscriberType;
}

export interface SubscriptionStatusCoordinator {
    isUserInHomeStorefront?: boolean;
    userInfo: UserInfo | null;
}

export function isSignedIn(objectGraph: ObjectGraph): boolean {
    const userInfoObj = userInfo(objectGraph);
    return userInfoObj !== null;
}

export function userInfo(objectGraph: ObjectGraph): UserInfo | null {
    const subscriptionStatusCoordinator = inject(
        ObjectGraphType.subscriptionStatusCoordinator,
        objectGraph,
    );
    return subscriptionStatusCoordinator.userInfo;
}

export function isPremiumSubscriber(objectGraph: ObjectGraph): boolean {
    const subscriptionStatusCoordinator = inject(
        ObjectGraphType.subscriptionStatusCoordinator,
        objectGraph,
    );
    return (
        subscriptionStatusCoordinator?.userInfo?.subscriberType ===
        SubscriberType.Premium
    );
}

export function isNonSubscriber(objectGraph: ObjectGraph): boolean {
    const subscriptionStatusCoordinator = inject(
        ObjectGraphType.subscriptionStatusCoordinator,
        objectGraph,
    );
    return (
        subscriptionStatusCoordinator?.userInfo?.subscriberType ===
        SubscriberType.NotActive
    );
}
